<template>
  <b-card body-class="card-body">
    <b-card-text>
      <h6>
        {{ value
        }}<small v-if="valueTarget" class="text-muted">
          / {{ valueTarget }}</small
        >
      </h6>
      <h6>{{ title }}</h6>

      <bar-chart
        :data="chartData"
        :name="title"
        :value-formatter="valueFormatter"
      />
    </b-card-text>
  </b-card>
</template>

<script>
import Vue from 'vue';
import BarChart from './BarChart';

export default Vue.extend({
  props: {
    title: String,
    value: [String, Number],
    'no-chart': {
      type: Boolean,
      default: false,
    },
    valueTarget: [String, Number],
    data: {
      type: Array,
    },
    dataValueName: {
      type: String,
      default: 'value',
    },
    valueFormatter: {
      type: Function,
    },
  },
  components: {
    BarChart,
  },
  computed: {
    chartData() {
      if (this.data && Array.isArray(this.data)) {
        return this.data.reduce((acc, curr) => {
          acc.push({ x: curr.date, y: curr[this.dataValueName] });
          return acc;
        }, []);
      }
      return [];
    },
  },
});
</script>

<style scoped>
.echarts {
  width: 100%;
  height: 100%;
}
.card {
  border-top: 3px solid #4d92e3;
}
.card-body {
  color: #4d92e3;
}
.card-body h6 {
  font-weight: 600;
}
</style>
